import { Button, Flex, Panel, PanelSection } from '@customerio/pluma-components/react';
import { SafeNavigate } from '@/services/router/safe-navigate';
import { RelationshipsStep } from '../../new/components/relationships-step';
import { useSqlImportDetail } from '../context';
import { relationshipsQueryWriteBody } from '../edit';
import { useEditableQuery } from './use-editable-query';

/** The Relationship Query tab: the query relating the imported rows, previewed and saved with `update_query`. */
export function RelationshipsQueryTab() {
  const { sqlImport, hrefs } = useSqlImportDetail();
  // The tab is only offered to an import with a relationship; a typed-in URL goes back to the runs.
  if (sqlImport.relationship == null) {
    return <SafeNavigate to={hrefs.imports} options={{ shouldReplaceHistoryEntry: true }} />;
  }
  return <RelationshipsQueryEditor />;
}

function RelationshipsQueryEditor() {
  const { detail, edits, steps, save, isSaving } = useEditableQuery();
  const { type, objectTypes, canEdit, canIdentifyByEmail } = detail;

  const canSave = canEdit && edits.isDirty && steps.hasSuccessfulRelationshipsQuery;

  return (
    <Panel>
      <PanelSection>
        <RelationshipsStep
          type={type}
          draft={edits.draft}
          relationship={steps.relationship}
          objectTypes={objectTypes}
          isReadOnly={!canEdit}
          canIdentifyByEmail={canIdentifyByEmail}
          isObjectTypeLocked
          run={steps.relationshipsRun}
          onChange={steps.setRelationship}
          onRun={steps.runRelationshipsQuery}
          onTimeoutDismiss={() => steps.dismissTimeout(true)}
          onTimeoutContinue={() => steps.continueAfterTimeout(true)}
        />
        <Flex justifyContent="flex-end" mt="200">
          <Button
            variant="primary"
            isDisabled={!canSave}
            isLoading={isSaving}
            onClick={() => void save(edits.draft, relationshipsQueryWriteBody(edits.draft, steps.relationship))}
            data-test-sql-import-button="submit"
          >
            Save changes
          </Button>
        </Flex>
      </PanelSection>
    </Panel>
  );
}
